<div class="sec-title">
    <h1>Contrats</h1>
  </div>
  
  <ul class="editing-list list-group">
    <li class="list-group-item list-group-header">
      <div class="card">
        <div class="row">
          <div class="col-lg-8 col-md-12">
          </div>
          <div class="col-lg-1 col-md-4 mt-4">
            <a class="btn btn-action btn-filter" [ngClass]="{'selected_filter': filter=='all'}" (click)="changeFilter('all')" role="button"> Tous</a>
          </div>
          <div class="col-lg-3 col-md-12 align-text-bottom header-action-btn">
            <form [formGroup]="searchContractForm" (ngSubmit)="onSubmit(searchContractForm.value)" novalidate>
              <div class="form-group input-group mb-3">
                <label for="search_contract" class="visually-hidden">Recherche</label>
                <input type="text" class="form-control" name="search_contract" id="search_contract" formControlName="search_contract" placeholder="Recherche...">
                <div class="input-group-append">
                  <button type="submit" class="input-group-text right-action-btn">
                    <i title="Recherche" class="bi bi-search"></i>
                    <span class="visually-hidden">Rechercher</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-10 col-md-10">
              <div class="row">
                <div class="col-lg-6 col-md-6">Adresse</div>
                <div class="col-lg-4 col-md-4">Client</div>
                <div class="col-lg-2 col-md-2">Contrat</div>
              </div>
            </div>
            <div class="col-md-1 d-flex justify-content-end action-icons">
              <div>Modifier</div>
            </div>
        </div>
        </div>
      </div>
    </li>
    <li class="list-group-item" *ngIf="total === 0 && isSearch == true">
      <div class="card">
        <div class="card-body">
          <div class="row mt-3 ms-3 mb-3 strong">
                {{no_results_message}}
          </div>
        </div>
      </div>
    </li>
    <li *ngIf="diplay_loading != '' && isSearch == false; else Results" class="list-group-item">
      <div class="card">
        <div class="card-body">  
          <div class="mt-3 ms-3 mb-3 strong">
            {{ diplay_loading }} 
            <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
            <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
            <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
          </div>
        </div>
      </div>
    </li>
    <ng-template #Results>
    <li class="list-group-item" [ngClass]="{'submisison_refused' : contract.is_refused }" *ngFor="let contract of contractsList | paginate: { itemsPerPage: limits, currentPage: p+1, totalItems: total}; let i = index">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-10">
              <div class="row">
                <div class="col-md-6">
                  <div class="card-subtitle mb-2 txt-strong">
                    <address>
                      {{contract.address}}, {{contract.city}}, 
                      {{contract.province}} {{contract.address2}} 
                      {{contract.country}}
                    </address>
                  </div>
                </div>
                <div class="col-md-4">
                  <ng-container>
                    <ng-container>
                      <p class="card-text">
                        <a routerLink="/client/{{contract.client_id}}/editer"><i class="bi bi-link"></i>{{contract.client_first_name}} {{contract.client_last_name}}</a>
                      </p>
                    </ng-container>
                  </ng-container>
                </div>
                <div class="col-md-2">
                  <p class="card-title card-title-main">#{{contract.submission_no}}</p>
                </div>
                
              </div>
            </div>
            <div class="col-md-2">
              <div class="d-flex justify-content-end action-icons">
                <button type="button" class="btn btn-outline-secondary left-action-btn" (click)="editClient(contract.client_id)">
                  <i class="bbi bi bi-person" title="Modifier le client"></i>
                </button>
                <button type="button" class="btn btn-outline-secondary middle-action-btn" (click)="modifyContract(contract.submission_id)">
                  <i class="bi bi-pencil-square" title="Modifier le contrat"></i>
                </button>
                <button type="button" class="btn btn-outline-secondary middle-action-btn" [ngClass]="(contract.count_order == 0)? 'add-btn' : '' " (click)="addOrder(contract.submission_id, contract.count_order, contract.submission_order)">
                  <i  *ngIf="contract.count_order == 0" class="bi bi-cart-plus" title="Ajouter un bon de commande"></i>
                  <i  *ngIf="contract.count_order > 0" class="bi bi-cart-check" title="Modifier le bon de commande"></i>
                </button>
                <button type="button" class="btn btn-outline-secondary right-action-btn" [ngClass]="(contract.count_invoice == 0)? 'add-btn' : '' " (click)="addInvoice(contract.submission_id, contract.count_invoice, contract.submission_invoice)">
                  <i *ngIf="contract.count_invoice == 0" class="bi bi-currency-dollar" title="Facturer"></i>
                  <i *ngIf="contract.count_invoice >0" class="bi bi-cash-coin" title="Modifier la Facture"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
    </ng-template>
  </ul>

  <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>